import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {MenuListComponentProps} from 'react-select';

import {CogIcon} from '../icon/svg/cog-icon';
import {StackLegacy} from '../layout/stack/stack-legacy';

import type {FooterButtonProps} from './select-picker-generic';

import styles from './custom-menu-list.module.css';

type SelectPropsWithMenuContent = {
    footerButton?: FooterButtonProps;
    menuListHeader?: React.ReactNode;
    menuListFooter?: React.ReactNode;
};

export const CustomMenuList = ({children, ...props}: MenuListComponentProps) => {
    const {footerButton, menuListHeader, menuListFooter} =
        props.selectProps as SelectPropsWithMenuContent;
    const Icon = (footerButton && footerButton.icon) || CogIcon;

    return (
        <>
            <components.MenuList {...props}>
                {menuListHeader && (
                    <div className={styles['menu-list-header']}>{menuListHeader}</div>
                )}
                {children}
                {menuListFooter}
            </components.MenuList>
            {footerButton && (
                <div onClick={footerButton.onClick} className={styles['fixed-footer']}>
                    <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                        <Icon size={13} alignCenter={true} />
                        <div>{footerButton.label}</div>
                    </StackLegacy>
                </div>
            )}
        </>
    );
};

export const getCustomMenuList = () => CustomMenuList;
